// routes from pcs-cms

export const areaGuidesPath = '/cms/area-guides';
